import { render } from "./EntityUserDialog.vue?vue&type=template&id=2fe8e4ec&ts=true"
import script from "./EntityUserDialog.vue?vue&type=script&lang=ts"
export * from "./EntityUserDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__